var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgG4AiHero(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 677.149 598.293",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    opacity: 0.62,
    clipPath: "url(#clip0_0_65)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M676.723 388.52C682.94 302.512 536.581 221.846 349.822 208.348C163.063 194.85 6.62536 253.63 0.409 339.638C-5.80736 425.646 140.551 506.311 327.31 519.81C514.069 533.308 670.507 474.527 676.723 388.52Z",
    stroke: "var(--stroke-0, #959595)",
    strokeWidth: 0.463864,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M664.302 370.591C666.746 286.494 520.69 214.018 338.077 208.712C155.465 203.406 5.44702 267.28 3.00355 351.377C0.560087 435.475 146.616 507.951 329.229 513.256C511.841 518.562 661.859 454.689 664.302 370.591Z",
    stroke: "var(--stroke-0, #959595)",
    strokeWidth: 0.463864,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M331.153 506.769C509.619 503.882 653.217 434.904 651.887 352.702C650.557 270.501 504.804 206.203 326.337 209.09C147.871 211.977 4.27319 280.955 5.6029 363.157C6.93262 445.358 152.686 509.656 331.153 506.769Z",
    stroke: "var(--stroke-0, #959595)",
    strokeWidth: 0.463864,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M333.068 500.178C507.386 489.099 644.562 415.037 639.46 334.756C634.357 254.474 488.908 198.375 314.591 209.453C140.273 220.532 3.09647 294.594 8.1988 374.876C13.3011 455.157 158.75 511.257 333.068 500.178Z",
    stroke: "var(--stroke-0, #959595)",
    strokeWidth: 0.463865,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M334.954 493.605C505.118 474.339 635.869 395.185 626.995 316.81C618.121 238.435 472.983 190.519 302.819 209.786C132.655 229.053 1.90376 308.206 10.7777 386.581C19.6516 464.956 164.79 512.872 334.954 493.605Z",
    stroke: "var(--stroke-0, #959595)",
    strokeWidth: 0.463864,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M336.896 487.083C502.929 459.619 627.273 375.373 614.625 298.916C601.978 222.458 457.129 182.741 291.096 210.206C125.063 237.671 0.719063 321.916 13.3664 398.374C26.0138 474.831 170.863 514.548 336.896 487.083Z",
    stroke: "var(--stroke-0, #959595)",
    strokeWidth: 0.463864,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M338.858 480.526C500.756 444.867 618.688 355.52 602.267 280.963C585.845 206.407 441.289 174.873 279.39 210.532C117.492 246.191 -0.44046 335.538 15.981 410.095C32.4024 484.652 176.959 516.185 338.858 480.526Z",
    stroke: "var(--stroke-0, #959595)",
    strokeWidth: 0.463865,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M340.765 473.967C498.517 430.121 610.032 335.687 589.841 263.044C569.651 190.4 425.399 167.056 267.647 210.902C109.896 254.749 -1.61975 349.182 18.5711 421.826C38.762 494.469 183.013 517.814 340.765 473.967Z",
    stroke: "var(--stroke-0, #959595)",
    strokeWidth: 0.463864,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M342.681 467.411C496.292 415.364 601.391 315.836 577.427 245.108C553.463 174.38 409.51 159.237 255.899 211.284C102.288 263.331 -2.81195 362.86 21.1522 433.587C45.1164 504.315 189.07 519.458 342.681 467.411Z",
    stroke: "var(--stroke-0, #959595)",
    strokeWidth: 0.463864,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M344.588 460.843C494.046 400.608 592.724 295.995 564.991 227.183C537.258 158.371 393.617 151.417 244.159 211.651C94.7014 271.885 -3.97631 376.498 23.7564 445.311C51.4891 514.123 195.13 521.077 344.588 460.843Z",
    stroke: "var(--stroke-0, #959595)",
    strokeWidth: 0.463864,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M346.492 454.298C491.812 385.87 584.076 276.156 552.569 209.244C521.061 142.331 377.714 143.56 232.394 211.987C87.0735 280.415 -5.19024 390.13 26.317 457.042C57.8243 523.954 201.171 522.726 346.492 454.298Z",
    stroke: "var(--stroke-0, #959595)",
    strokeWidth: 0.463865,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M348.397 447.744C489.573 371.124 575.42 256.315 540.14 191.311C504.861 126.307 361.816 135.723 220.64 212.343C79.4635 288.963 -6.38283 403.771 28.8964 468.775C64.1757 533.779 207.221 524.363 348.397 447.744Z",
    stroke: "var(--stroke-0, #959595)",
    strokeWidth: 0.463864,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M350.331 441.194C487.348 356.386 566.77 236.495 527.723 173.41C488.676 110.325 345.947 127.935 208.929 212.743C71.9117 297.552 -7.50947 417.443 31.5374 480.528C70.5843 543.612 213.313 526.002 350.331 441.194Z",
    stroke: "var(--stroke-0, #959595)",
    strokeWidth: 0.463864,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M352.243 434.664C485.126 341.663 558.136 216.673 515.316 155.489C472.495 94.3051 330.06 120.098 197.177 213.098C64.2936 306.098 -8.71662 431.089 34.1038 492.273C76.9241 553.456 219.36 527.664 352.243 434.664Z",
    stroke: "var(--stroke-0, #959595)",
    strokeWidth: 0.463864,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M354.195 428.069C482.938 326.869 549.532 196.778 502.938 137.502C456.344 78.2261 314.205 112.212 185.462 213.412C56.7185 314.612 -9.87623 444.703 36.7181 503.979C83.3124 563.254 225.451 529.268 354.195 428.069Z",
    stroke: "var(--stroke-0, #959595)",
    strokeWidth: 0.463864,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M356.094 421.577C480.695 312.196 540.876 177.017 490.512 119.645C440.149 62.2732 298.312 104.434 173.711 213.815C49.1098 323.195 -11.0715 458.374 39.2921 515.746C89.6558 573.118 231.493 530.957 356.094 421.577Z",
    stroke: "var(--stroke-0, #959595)",
    strokeWidth: 0.463864,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M357.993 414.995C478.438 297.428 532.196 157.164 478.065 101.708C423.934 46.2521 282.412 96.6029 161.967 214.17C41.5217 331.737 -12.2366 472 41.8944 527.457C96.0253 582.913 237.547 532.562 357.993 414.995Z",
    stroke: "var(--stroke-0, #959595)",
    strokeWidth: 0.463864,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M359.909 408.433C476.229 282.656 523.593 137.29 465.698 83.7483C407.804 30.2065 266.575 88.7644 150.255 214.541C33.9344 340.318 -13.429 485.684 44.4654 539.226C102.36 592.767 243.589 534.209 359.909 408.433Z",
    stroke: "var(--stroke-0, #959595)",
    strokeWidth: 0.463864,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M361.801 401.901C473.97 267.945 514.919 117.499 453.264 65.8716C391.609 14.2442 250.696 80.9851 138.527 214.942C26.3575 348.898 -14.592 499.344 47.0634 550.971C108.719 602.599 249.631 535.858 361.801 401.901Z",
    stroke: "var(--stroke-0, #959595)",
    strokeWidth: 0.463865,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M363.746 395.375C471.778 253.225 506.31 97.6754 440.875 47.9457C375.44 -1.78397 234.817 73.1375 126.785 215.287C18.7531 357.437 -15.7784 512.987 49.6567 562.716C115.092 612.446 255.715 537.525 363.746 395.375Z",
    stroke: "var(--stroke-0, #959595)",
    strokeWidth: 0.463865,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M365.616 388.809C469.502 238.471 497.625 77.8378 428.432 30.0237C359.238 -17.7903 218.929 65.3215 115.043 215.659C11.1571 365.997 -16.9665 526.631 52.2272 574.445C121.421 622.259 261.73 539.147 365.616 388.809Z",
    stroke: "var(--stroke-0, #959595)",
    strokeWidth: 0.463864,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M367.531 382.271C467.267 223.743 488.968 58.0171 416.003 12.1122C343.038 -33.7927 203.037 57.5066 103.301 216.035C3.5653 374.563 -18.1366 540.289 54.8285 586.194C127.794 632.099 267.795 540.799 367.531 382.271Z",
    stroke: "var(--stroke-0, #959595)",
    strokeWidth: 0.463865,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_65"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 677.149,
    height: 598.293,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgG4AiHero);
export default __webpack_public_path__ + "static/media/g4ai-hero.9f9efdaf4c5e5a9e4eaa3856a4b1a945.svg";
export { ForwardRef as ReactComponent };